import * as secureStorage from '../common/custom/secureStorage';

(function () {
  const encryptor = {
    ...secureStorage,
  };

  Object.freeze(encryptor);

  if (!Object.prototype.hasOwnProperty.call(window, 'oaCommonsUiEncryptor')) {
    Object.defineProperty(window, 'oaCommonsUiEncryptor', {
      value: encryptor,
      writable: false,
      configurable: false,
      enumerable: true,
    });
  }
})();
